import SwitchElement from '@mui/material/Switch';
//import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';

import { getColors, getDarkMode } from '@/utils/Settings';

//https://mui.com/material-ui/react-switch/
export default function Switch({
	id,
	name,
	checked,
	onChange,
	value,
	defaultChecked,
	disabled,
	required,
	label,
	labelPlacement,
	size,
	color,
	sx,
	sxSwitch,
	fontSize,
	fontWeight,
	multilabel,
	labeldisabled,
	labelenabled
}){

	const { lightColor,lightColorGradient,darkColor,darkColorGradient } = getColors();
	const darkmode = getDarkMode();

	var sxSwitchConfig = null;

	var colorSwitch = '';
	if(color){
		colorSwitch = color;
	}
	else{

		sxSwitchConfig = {
			
			"& .MuiSwitch-track": {
	        	backgroundColor: darkmode ? darkColor : '#333333'//'rgb(115 115 115)'
	        },
	        '& .MuiSwitch-switchBase.Mui-checked': {
			    color: darkmode ? darkColor : lightColor,
			    '&:hover': {
			      backgroundColor: darkmode ? darkColorGradient : lightColorGradient,
			    },
		  	},
		  	// the horizontal bar when unchecked
			'& .MuiSwitch-switchBase.MuiSwitch-switchBase + .MuiSwitch-track': {
			    backgroundColor: darkmode ? '#FFFFFF' : null
			},
		  	// the horizontal bar when checked
			'& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
			    backgroundColor: darkmode ? darkColor : lightColor
			}			
		};
	}

	if(sxSwitch){
		sxSwitchConfig = {...sxSwitchConfig,...sxSwitch};
	}

	/*
	var sxConfig = {
		padding:0,
		marginLeft:labelPlacement === 'start' || labelPlacement === 'top' ? 1 : multilabel ? 2 : 0,
		marginRight:0,		
		'& .MuiFormControlLabel-root' : {
    		marginLeft: '-10px !important'
    	}
	};
	*/

	var sxLabelTop = {};
	let sxConfig;
	if(multilabel){
		sxConfig = {
			padding:0,
			marginLeft: 2,
			marginRight:0
		};

		sxLabelTop = {...sxConfig};
		sxLabelTop.color = darkmode ? darkColor : lightColor;
	}
	else{
		sxConfig = {
			padding:0,
			marginLeft:labelPlacement === 'start' || labelPlacement === 'top' ? 1.5 : -1,
			marginRight:0,
			color: darkmode ? darkColor : lightColor,
			alignItems: 'center'
		};
	}
	
	if(sx){
		sxConfig = {...sxConfig,...sx};
	}

	/*
	if(darkmode){
		sxConfig = {
			"& .MuiSwitch-track": {
        		backgroundColor: '#FFFFFF'//'rgb(115 115 115)'
        	}
    	};
    }
    */

    const componentsProps = {
    	
    };

    if(fontSize){ 

    	if(multilabel){
    		sxConfig.fontSize = fontSize;
    		sxLabelTop.fontSize = fontSize;
    	}
    	else{
    		componentsProps.typography = { /*variant: 'h1'*/ fontSize:fontSize };
    	}
    }

    if(fontWeight){ 

    	if(multilabel){
    		sxConfig.fontWeight = fontWeight;
    		sxLabelTop.fontWeight = fontWeight;
    	}
    	else{
    		componentsProps.typography = { fontWeight: fontWeight};
    	}
    }

    return (
    	multilabel ? 
    		<>
    		<div>
    			<Typography sx={sxLabelTop}>{label}</Typography>
    		</div>
    		<FormControlLabel   
				sx={sxConfig}				
				control={
					<div className='flex items-center'>
						<div>{labeldisabled}</div>
						<SwitchElement
							sx={sxSwitchConfig} 
							id={id}
							name={name}
							checked={checked}
							onChange={onChange}
							value={value}  						
							defaultChecked={defaultChecked}
							size={size}
							color={colorSwitch}  						
						/>
						<div>{labelenabled}</div>
					</div>
				}
				disabled={disabled}
				required={required}
			/>
			</>
    	:
			<FormControlLabel   
				sx={sxConfig}
				componentsProps={componentsProps}
				control={
					<SwitchElement
						sx={sxSwitchConfig} 
						id={id}
						name={name}
						checked={checked}
						onChange={onChange}
						value={value}  						
						defaultChecked={defaultChecked}
						size={size}
						color={colorSwitch}  						
					/>
				}
				label={label}
				labelPlacement={labelPlacement} // start, end, top, bottom
				disabled={disabled}
				required={required}
			/>
    );
}
